export interface ICandidateInterviewQuestions {
	type: CandidateInterviewQuestonTypes;
	interviewDate: string;
	firstName: string;
	lastName: string;
	email: string;
	contactNumber: string;
	postcode: string;
	startDate: string;
	typeOfWork: string;
	employmentType: CandidateInterviewWorkTypes;
	transport: string;
	durationOfTravel: string;
	ageGroupPreference: string;
	subjects: string;
	whyTeacher: string;
	qualities: string;
	experienceAdditionalNeeds: boolean;
	experienceAdditionalNeedsDescription: string;
	successDescription: string;
	teachingStyle: string;
	adaptingWork: string;
	specalistSubjects: string;
	challengingBehaviourScenario: string;
	challengingBehaviourSolution: string;
	confirmGaps: string;
	mostRecentEmployment: string;
	rolesOrClubs: string;
	otherAgencies: string;
	teaching360: boolean;
	currentDbs: boolean;
	updateService: boolean;
	updateServiceApply: boolean;
	askedToLeave: boolean;
	dismissed: boolean;
	disciplinaryAction: boolean;
	criminalConvictions: boolean;
	safeguardingAllegations: string;
	childAtRisk: string;
	safeguardingDescription: string;
	confidence: string;
	interviewerName: string;
	interviewersEmail: string;
	strengthsSupport: string;
	notCooperatingScenario: string;
	notCooperatingScenarioSolution: string;
	behaviourManagement: string;
	schoolPreference: string;
	siblingsConflict: string;
	safeguardinRresponsibilities: boolean;
	safeguardinRresponsibilitiesSolution: string;
	videoInterview: string;
	//send
	schoolsWorked: string;
	registeredAgencies: string;
	educationAdditionalNeedsJustification: string;
	previousAdditionalNeedsExperience: string;
	educationAdditionalNeedsDescription: string;
	additionalNeedsAchievement: string;
	transferableSkills: string;
	additionalNeedsQuality: string;
	differenceMade: string;
	sendTaRole: string;
	resilience: string;
	mostRecentExperience?: string;
	typesOfSend?: string;
	happyPersonalCare?: string;
	extraTraining?: string;
	recentSafeGuardingTraining?: string;
	childSecret?: string;
	difficultBehaviour?: string;
	exampleChallengingBehaviourSend?: string;
	therapeuticApproachExample?: string;
	//ta
	previousTa: boolean;
	whyTa: string;
	keyRoleTa: string;
	skillsAsTa: string;
	skillsImportantAsTa: string;
	differenceAsTa: string;
	adjustmentsAdditionalNeeds: string;
	//primary
	whyPrimary: string;
	successTeacher: string;
	differenceAsTeacher: string;
	//approval
	candidateApprovalSent?: string;
	candidateApprovalSignature?: string;
	candidateApprovalDrawnSignature?: string;
	candidateApprovalSignatureDate?: string;
	candidateApprovalNote?: string;
	//exam invigilator
	whyExamInvigilator?: string;
	experienceExamInvigilator?: string;
	keyRoleExamInvigilator?: string;
	//nurture teacher
	bespokeCurriculum?: string;
	tailoredLearning?: string;
	specialNeedsExperience?: string;
	teachingApproach?: string;
	successfulOutcomes?: string;
	stayingInformed?: string;
	recentTraining?: string;
	applyingKnowledge?: string;
	therapeuticApproach?: string;
	supportingSensoryNeeds?: string;
	sensoryNeedsStrategies?: string;
	preferredAgeSend?: string;
	favouriteSubjectSend?: string;
	engagingMaterial?: string;
	challengingBehaviourSend?: string;
	proactiveMeasures?: string;
	safeguardSendStudents?: string;
	signsOfDistress?: string;
	handledSendSafeguardingIssue?: string;
	//nursery
	whyNursery?: string;
	helpedChild?: string;
	supportChildDevelopment?: string;
	ensureSafety?: string;
	communicateWithParents?: string;
	ageGroupExperience?: string;
	validDBSCheck?: string;
	//tutor
	tutorAttraction?: string;
	tutorQualities?: string;
	tutorTransferableSkills?: string;
	tutorImportantQuality?: string;
	tutorIntervention?: string;
	tutorOnetoOne?: string;
	tutorVulnerable?: string;
	tutorAdditionalNeeds?: string;
	tutorAchievement?: string;
	tutorCYP?: string;
	//admin
	adminExperience?: string;
	adminOfficeEnvironment?: string;
	adminStayOrganised?: string;
	adminExperienceWord?: boolean;
	adminExperienceSims?: boolean;
	adminExperienceArbor?: boolean;
	adminExperienceFinance6?: boolean;
	//catering
	cateringExperience?: string;
	cateringRoleUnderstanding?: string;
	cateringWorkloadManagement?: string;
	cateringMotivation?: string;
	cateringFoodHygieneSafety?: string;
	cateringSafetyStandards?: string;
	cateringCrossContamination?: string;
	cateringIllnessManagement?: string;
	cateringTeamwork?: string;
	cateringDissagreement?: string;
	cateringCommunication?: string;
	cateringGovernance?: string;
	cateringLogManagement?: string;
	cateringOfsted?: string;
	cateringRefusal?: string;
	cateringSecondHelpings?: string;
	cateringSafeWelcome?: string;
	//caretaker
	caretakerBasicPlumbing?: boolean;
	caretakerElectricalMaintenance?: boolean;
	caretakerGroundsKeeping?: boolean;
	caretakerCleaning?: boolean;
	caretakerHealthSafety?: boolean;
	caretakerToolUsage?: boolean;
	caretakerOtherSkills?: string;
	caretakerUrgentRepair?: string;
	caretakerSafetyHazards?: string;
	caretakerMainenanceBalance?: string;
	caretakerSecurity?: string;
	caretakerRegulationsBuilding?: boolean;
	caretakerHazardousSubstances?: string;
	caretakerHazardClearning?: boolean;
	caretakerQualifications?: string;
	//cleaner
	cleanerExperience?: string;
	cleanerSchoolExperience?: string;
	cleanerEnjoment?: string;
	cleanerManageTime?: string;
	cleanerSkill?: boolean;
	cleaningEquipment?: boolean;
	cleaningDeepCleaning?: boolean;
	cleaningHealthSafety?: boolean;
	cleaningChemicals?: boolean;
	cleaningOtherSkills?: string;
	cleanerUrgentCleaning?: string;
	cleanerPotentialHazards?: string;
	cleanerBalanceCleaning?: string;
	cleanerResponsibility?: string;
	flexibleHours?: string;
	openToDaytoDay?: boolean;
	openToShortTerm?: boolean;
	openToLongTerm?: boolean;
	currentAvailabilties?: string;
	distanceToTravel?: string;
	askedToLeaveDescription?: string;
	dismissedDescription?: string;
	disciplinaryActionDescription?: string;
	criminalConvictionsDescription?: string;
}

export enum CandidateInterviewQuestonTypes {
	Secondary = 1,
	SENDTA = 2,
	Primary = 3,
	GeneralTA = 4,
	CoverSupervisor = 5,
	ExamInvigilator = 6,
	NurseryTeacher = 7,
	NurtureTeacher = 8,
	Tutor = 9,
	Admin = 10,
	Catering = 11,
	Caretaker = 12,
	Cleaner = 13,
}

export enum CandidateInterviewWorkTypes {
	Full = 1,
	Part = 2,
	Both = 3,
}

export class CandidateInterviewModel implements ICandidateInterviewQuestions {
	type: CandidateInterviewQuestonTypes;
	interviewDate: string;
	firstName: string;
	lastName: string;
	email: string;
	contactNumber: string;
	postcode: string;
	startDate: string;
	typeOfWork: string;
	employmentType: CandidateInterviewWorkTypes;
	transport: string;
	durationOfTravel: string;
	ageGroupPreference: string;
	subjects: string;
	whyTeacher: string;
	qualities: string;
	experienceAdditionalNeeds: boolean;
	experienceAdditionalNeedsDescription: string;
	successDescription: string;
	teachingStyle: string;
	adaptingWork: string;
	specalistSubjects: string;
	challengingBehaviourScenario: string;
	challengingBehaviourSolution: string;
	confirmGaps: string;
	mostRecentEmployment: string;
	rolesOrClubs: string;
	otherAgencies: string;
	teaching360: boolean;
	currentDbs: boolean;
	updateService: boolean;
	updateServiceApply: boolean;
	askedToLeave: boolean;
	dismissed: boolean;
	disciplinaryAction: boolean;
	criminalConvictions: boolean;
	safeguardingAllegations: string;
	childAtRisk: string;
	safeguardingDescription: string;
	confidence: string;
	interviewerName: string;
	interviewersEmail: string;
	strengthsSupport: string;
	notCooperatingScenario: string;
	notCooperatingScenarioSolution: string;
	behaviourManagement: string;
	schoolPreference: string;
	siblingsConflict: string;
	safeguardinRresponsibilities: boolean;
	safeguardinRresponsibilitiesSolution: string;
	videoInterview: string;
	askedToLeaveDescription?: string;
	dismissedDescription?: string;
	disciplinaryActionDescription?: string;
	criminalConvictionsDescription?: string;
	//send
	schoolsWorked: string;
	registeredAgencies: string;
	educationAdditionalNeedsJustification: string;
	previousAdditionalNeedsExperience: string;
	educationAdditionalNeedsDescription: string;
	additionalNeedsAchievement: string;
	transferableSkills: string;
	additionalNeedsQuality: string;
	differenceMade: string;
	sendTaRole: string;
	resilience: string;
	mostRecentExperience?: string;
	typesOfSend?: string;
	happyPersonalCare?: string;
	extraTraining?: string;
	recentSafeGuardingTraining?: string;
	childSecret?: string;
	difficultBehaviour?: string;
	exampleChallengingBehaviourSend?: string;
	therapeuticApproachExample?: string;
	//ta
	previousTa: boolean;
	whyTa: string;
	keyRoleTa: string;
	skillsAsTa: string;
	skillsImportantAsTa: string;
	differenceAsTa: string;
	adjustmentsAdditionalNeeds: string;
	//primary
	whyPrimary: string;
	successTeacher: string;
	differenceAsTeacher: string;
	//candidate approval
	candidateApprovalSent?: string;
	candidateApprovalSignature?: string;
	candidateApprovalDrawnSignature?: string;
	candidateApprovalSignatureDate?: string;
	candidateApprovalNote?: string;
	//exam invigilator
	whyExamInvigilator?: string;
	experienceExamInvigilator?: string;
	keyRoleExamInvigilator?: string;
	//nurture teacher
	bespokeCurriculum?: string;
	tailoredLearning?: string;
	specialNeedsExperience?: string;
	teachingApproach?: string;
	successfulOutcomes?: string;
	stayingInformed?: string;
	recentTraining?: string;
	applyingKnowledge?: string;
	therapeuticApproach?: string;
	supportingSensoryNeeds?: string;
	sensoryNeedsStrategies?: string;
	preferredAgeSend?: string;
	favouriteSubjectSend?: string;
	engagingMaterial?: string;
	challengingBehaviourSend?: string;
	proactiveMeasures?: string;
	safeguardSendStudents?: string;
	signsOfDistress?: string;
	handledSendSafeguardingIssue?: string;
	///nursery
	whyNursery?: string;
	helpedChild?: string;
	supportChildDevelopment?: string;
	ensureSafety?: string;
	communicateWithParents?: string;
	ageGroupExperience?: string;
	validDBSCheck?: string;
	//tutor
	tutorAttraction?: string;
	tutorQualities?: string;
	tutorTransferableSkills?: string;
	tutorImportantQuality?: string;
	tutorIntervention?: string;
	tutorOnetoOne?: string;
	tutorVulnerable?: string;
	tutorAdditionalNeeds?: string;
	tutorAchievement?: string;
	tutorCYP?: string;
	//admin
	adminExperience?: string;
	adminOfficeEnvironment?: string;
	adminStayOrganised?: string;
	adminExperienceWord?: boolean;
	adminExperienceSims?: boolean;
	adminExperienceArbor?: boolean;
	adminExperienceFinance6?: boolean;
	//catering
	cateringExperience?: string;
	cateringRoleUnderstanding?: string;
	cateringWorkloadManagement?: string;
	cateringMotivation?: string;
	cateringFoodHygieneSafety?: string;
	cateringSafetyStandards?: string;
	cateringCrossContamination?: string;
	cateringIllnessManagement?: string;
	cateringTeamwork?: string;
	cateringDissagreement?: string;
	cateringCommunication?: string;
	cateringGovernance?: string;
	cateringLogManagement?: string;
	cateringOfsted?: string;
	cateringRefusal?: string;
	cateringSecondHelpings?: string;
	cateringSafeWelcome?: string;
	//caretaker
	caretakerBasicPlumbing?: boolean;
	caretakerElectricalMaintenance?: boolean;
	caretakerGroundsKeeping?: boolean;
	caretakerCleaning?: boolean;
	caretakerHealthSafety?: boolean;
	caretakerToolUsage?: boolean;
	caretakerOtherSkills?: string;
	caretakerUrgentRepair?: string;
	caretakerSafetyHazards?: string;
	caretakerMainenanceBalance?: string;
	caretakerSecurity?: string;
	caretakerRegulationsBuilding?: boolean;
	caretakerHazardousSubstances?: string;
	caretakerHazardClearning?: boolean;
	caretakerQualifications?: string;
	//cleaner
	cleanerExperience?: string;
	cleanerSchoolExperience?: string;
	cleanerEnjoment?: string;
	cleanerManageTime?: string;
	cleanerSkill?: boolean;
	cleaningEquipment?: boolean;
	cleaningDeepCleaning?: boolean;
	cleaningHealthSafety?: boolean;
	cleaningChemicals?: boolean;
	cleaningOtherSkills?: string;
	cleanerUrgentCleaning?: string;
	cleanerPotentialHazards?: string;
	cleanerBalanceCleaning?: string;
	cleanerResponsibility?: string;
	flexibleHours?: string;
	openToDaytoDay?: boolean;
	openToShortTerm?: boolean;
	openToLongTerm?: boolean;
	currentAvailabilties?: string;
	distanceToTravel?: string;

	constructor(data?: ICandidateInterviewQuestions) {
		this.type = data?.type || null;
		this.interviewDate = data?.interviewDate || "";
		this.firstName = data?.firstName || "";
		this.lastName = data?.lastName || "";
		this.email = data?.email || "";
		this.contactNumber = data?.contactNumber || "";
		this.postcode = data?.postcode || "";
		this.startDate = data?.startDate || "";
		this.typeOfWork = data?.typeOfWork || null;
		this.employmentType = data?.employmentType || null;
		this.transport = data?.transport || "";
		this.durationOfTravel = data?.durationOfTravel || "";
		this.ageGroupPreference = data?.ageGroupPreference || "";
		this.subjects = data?.subjects || "";
		this.whyTeacher = data?.whyTeacher || "";
		this.qualities = data?.qualities || "";
		this.experienceAdditionalNeeds = data?.experienceAdditionalNeeds !== null && data?.experienceAdditionalNeeds !== undefined ? data?.experienceAdditionalNeeds : null;
		this.experienceAdditionalNeedsDescription = data?.experienceAdditionalNeedsDescription || "";
		this.successDescription = data?.successDescription || "";
		this.teachingStyle = data?.teachingStyle || "";
		this.adaptingWork = data?.adaptingWork || "";
		this.specalistSubjects = data?.specalistSubjects || "";
		this.challengingBehaviourScenario = data?.challengingBehaviourScenario || "";
		this.challengingBehaviourSolution = data?.challengingBehaviourSolution || "";
		this.confirmGaps = data?.confirmGaps || "";
		this.mostRecentEmployment = data?.mostRecentEmployment || "";
		this.rolesOrClubs = data?.rolesOrClubs || "";
		this.otherAgencies = data?.otherAgencies || "";
		this.teaching360 = data?.teaching360 !== null && data?.teaching360 !== undefined ? data?.teaching360 : null;
		this.currentDbs = data?.currentDbs !== null && data?.currentDbs !== undefined ? data?.currentDbs : null;
		this.updateService = data?.updateService !== null && data?.updateService !== undefined ? data?.updateService : null;
		this.updateServiceApply = data?.updateServiceApply !== null && data?.updateServiceApply !== undefined ? data?.updateServiceApply : null;
		this.askedToLeave = data?.askedToLeave !== null && data?.askedToLeave !== undefined ? data?.askedToLeave : null;
		this.dismissed = data?.dismissed !== null && data?.dismissed !== undefined ? data?.dismissed : null;
		this.disciplinaryAction = data?.disciplinaryAction !== null && data?.disciplinaryAction !== undefined ? data?.disciplinaryAction : null;
		this.safeguardingAllegations = data?.safeguardingAllegations || "";
		this.childAtRisk = data?.childAtRisk || "";
		this.criminalConvictions = data?.criminalConvictions !== null && data?.criminalConvictions !== undefined ? data?.criminalConvictions : null;
		this.safeguardingDescription = data?.safeguardingDescription || "";
		this.confidence = data?.confidence || "";
		this.interviewerName = data?.interviewerName || "";
		this.interviewersEmail = data?.interviewersEmail || "";
		this.schoolsWorked = data?.schoolsWorked || "";
		this.registeredAgencies = data?.registeredAgencies || "";
		this.educationAdditionalNeedsJustification = data?.educationAdditionalNeedsJustification || "";
		this.previousAdditionalNeedsExperience = data?.previousAdditionalNeedsExperience || "";
		this.educationAdditionalNeedsDescription = data?.educationAdditionalNeedsDescription || "";
		this.additionalNeedsAchievement = data?.additionalNeedsAchievement || "";
		this.transferableSkills = data?.transferableSkills || "";
		this.additionalNeedsQuality = data?.additionalNeedsQuality || "";
		this.differenceMade = data?.differenceMade || "";
		this.sendTaRole = data?.sendTaRole || "";
		this.resilience = data?.resilience || "";
		this.mostRecentExperience = data?.mostRecentExperience || "";
		this.typesOfSend = data?.typesOfSend || "";
		this.happyPersonalCare = data?.happyPersonalCare || "";
		this.extraTraining = data?.extraTraining || "";
		this.recentSafeGuardingTraining = data?.recentSafeGuardingTraining || "";
		this.childSecret = data?.childSecret || "";
		this.difficultBehaviour = data?.difficultBehaviour || "";
		this.exampleChallengingBehaviourSend = data?.exampleChallengingBehaviourSend || "";
		this.therapeuticApproachExample = data?.therapeuticApproachExample || "";
		this.previousTa = data?.previousTa !== null && data?.previousTa !== undefined ? data?.previousTa : null;
		this.whyTa = data?.whyTa || "";
		this.keyRoleTa = data?.keyRoleTa || "";
		this.skillsAsTa = data?.skillsAsTa || "";
		this.skillsImportantAsTa = data?.skillsImportantAsTa || "";
		this.differenceAsTa = data?.differenceAsTa || "";
		this.adjustmentsAdditionalNeeds = data?.adjustmentsAdditionalNeeds || "";
		this.whyPrimary = data?.whyPrimary || "";
		this.successTeacher = data?.successTeacher || "";
		this.differenceAsTeacher = data?.differenceAsTeacher || "";
		this.strengthsSupport = data?.strengthsSupport || "";
		this.notCooperatingScenario = data?.notCooperatingScenario || "";
		this.notCooperatingScenarioSolution = data?.notCooperatingScenarioSolution || "";
		this.behaviourManagement = data?.behaviourManagement || "";
		this.schoolPreference = data?.schoolPreference || "";
		this.siblingsConflict = data?.siblingsConflict || "";
		this.safeguardinRresponsibilities = data?.safeguardinRresponsibilities !== null && data?.safeguardinRresponsibilities !== undefined ? data?.safeguardinRresponsibilities : null;
		this.safeguardinRresponsibilitiesSolution = data?.safeguardinRresponsibilitiesSolution || "";
		this.videoInterview = data?.videoInterview || "";
		this.candidateApprovalSent = data?.candidateApprovalSent || null;
		this.candidateApprovalSignature = data?.candidateApprovalSignature || null;
		this.candidateApprovalDrawnSignature = data?.candidateApprovalDrawnSignature || null;
		this.candidateApprovalSignatureDate = data?.candidateApprovalSignatureDate || null;
		this.candidateApprovalNote = data?.candidateApprovalNote || null;
		this.whyExamInvigilator = data?.whyExamInvigilator || "";
		this.experienceExamInvigilator = data?.experienceExamInvigilator || "";
		this.keyRoleExamInvigilator = data?.keyRoleExamInvigilator || "";
		this.bespokeCurriculum = data?.bespokeCurriculum || "";
		this.tailoredLearning = data?.tailoredLearning || "";
		this.specialNeedsExperience = data?.specialNeedsExperience || "";
		this.teachingApproach = data?.teachingApproach || "";
		this.successfulOutcomes = data?.successfulOutcomes || "";
		this.stayingInformed = data?.stayingInformed || "";
		this.recentTraining = data?.recentTraining || "";
		this.applyingKnowledge = data?.applyingKnowledge || "";
		this.therapeuticApproach = data?.therapeuticApproach || "";
		this.supportingSensoryNeeds = data?.supportingSensoryNeeds || "";
		this.sensoryNeedsStrategies = data?.sensoryNeedsStrategies || "";
		this.preferredAgeSend = data?.preferredAgeSend || "";
		this.favouriteSubjectSend = data?.favouriteSubjectSend || "";
		this.engagingMaterial = data?.engagingMaterial || "";
		this.challengingBehaviourSend = data?.challengingBehaviourSend || "";
		this.proactiveMeasures = data?.proactiveMeasures || "";
		this.safeguardSendStudents = data?.safeguardSendStudents || "";
		this.signsOfDistress = data?.signsOfDistress || "";
		this.handledSendSafeguardingIssue = data?.handledSendSafeguardingIssue || "";
		this.whyNursery = data?.whyNursery || "";
		this.helpedChild = data?.helpedChild || "";
		this.supportChildDevelopment = data?.supportChildDevelopment || "";
		this.ensureSafety = data?.ensureSafety || "";
		this.communicateWithParents = data?.communicateWithParents || "";
		this.ageGroupExperience = data?.ageGroupExperience || "";
		this.validDBSCheck = data?.validDBSCheck || "";
		this.tutorAttraction = data?.tutorAttraction || "";
		this.tutorQualities = data?.tutorQualities || "";
		this.tutorTransferableSkills = data?.tutorTransferableSkills || "";
		this.tutorImportantQuality = data?.tutorImportantQuality || "";
		this.tutorIntervention = data?.tutorIntervention || "";
		this.tutorOnetoOne = data?.tutorOnetoOne || "";
		this.tutorVulnerable = data?.tutorVulnerable || "";
		this.tutorAdditionalNeeds = data?.tutorAdditionalNeeds || "";
		this.tutorAchievement = data?.tutorAchievement || "";
		this.tutorCYP = data?.tutorCYP || "";
		this.adminExperience = data?.adminExperience || "";
		this.adminOfficeEnvironment = data?.adminOfficeEnvironment || "";
		this.adminStayOrganised = data?.adminStayOrganised || "";
		this.adminExperienceWord = data?.adminExperienceWord !== null && data?.adminExperienceWord !== undefined ? data?.adminExperienceWord : null;
		this.adminExperienceSims = data?.adminExperienceSims !== null && data?.adminExperienceSims !== undefined ? data?.adminExperienceSims : null;
		this.adminExperienceArbor = data?.adminExperienceArbor !== null && data?.adminExperienceArbor !== undefined ? data?.adminExperienceArbor : null;
		this.adminExperienceFinance6 = data?.adminExperienceFinance6 !== null && data?.adminExperienceFinance6 !== undefined ? data?.adminExperienceFinance6 : null;
		this.askedToLeaveDescription = data?.askedToLeaveDescription || "";
		this.dismissedDescription = data?.dismissedDescription || "";
		this.disciplinaryActionDescription = data?.disciplinaryActionDescription || "";
		this.criminalConvictionsDescription = data?.criminalConvictionsDescription || "";
		//catering
		this.cateringExperience = data?.cateringExperience || "";
		this.cateringRoleUnderstanding = data?.cateringRoleUnderstanding || "";
		this.cateringWorkloadManagement = data?.cateringWorkloadManagement || "";
		this.cateringMotivation = data?.cateringMotivation || "";
		this.cateringFoodHygieneSafety = data?.cateringFoodHygieneSafety || "";
		this.cateringSafetyStandards = data?.cateringSafetyStandards || "";
		this.cateringCrossContamination = data?.cateringCrossContamination || "";
		this.cateringIllnessManagement = data?.cateringIllnessManagement || "";
		this.cateringTeamwork = data?.cateringTeamwork || "";
		this.cateringDissagreement = data?.cateringDissagreement || "";
		this.cateringCommunication = data?.cateringCommunication || "";
		this.cateringGovernance = data?.cateringGovernance || "";
		this.cateringLogManagement = data?.cateringLogManagement || "";
		this.cateringOfsted = data?.cateringOfsted || "";
		this.cateringRefusal = data?.cateringRefusal || "";
		this.cateringSecondHelpings = data?.cateringSecondHelpings || "";
		this.cateringSafeWelcome = data?.cateringSafeWelcome || "";
		//caretaker
		this.caretakerBasicPlumbing = data?.caretakerBasicPlumbing !== null && data?.caretakerBasicPlumbing !== undefined ? data?.caretakerBasicPlumbing : null;
		this.caretakerElectricalMaintenance = data?.caretakerElectricalMaintenance !== null && data?.caretakerElectricalMaintenance !== undefined ? data?.caretakerElectricalMaintenance : null;
		this.caretakerGroundsKeeping = data?.caretakerGroundsKeeping !== null && data?.caretakerGroundsKeeping !== undefined ? data?.caretakerGroundsKeeping : null;
		this.caretakerCleaning = data?.caretakerCleaning !== null && data?.caretakerCleaning !== undefined ? data?.caretakerCleaning : null;
		this.caretakerHealthSafety = data?.caretakerHealthSafety !== null && data?.caretakerHealthSafety !== undefined ? data?.caretakerHealthSafety : null;
		this.caretakerToolUsage = data?.caretakerToolUsage !== null && data?.caretakerToolUsage !== undefined ? data?.caretakerToolUsage : null;
		this.caretakerOtherSkills = data?.caretakerOtherSkills || "";
		this.caretakerUrgentRepair = data?.caretakerUrgentRepair || "";
		this.caretakerSafetyHazards = data?.caretakerSafetyHazards || "";
		this.caretakerMainenanceBalance = data?.caretakerMainenanceBalance || "";
		this.caretakerSecurity = data?.caretakerSecurity || "";
		this.caretakerRegulationsBuilding = data?.caretakerRegulationsBuilding !== null && data?.caretakerRegulationsBuilding !== undefined ? data?.caretakerRegulationsBuilding : null;
		this.caretakerHazardousSubstances = data?.caretakerHazardousSubstances || "";
		this.caretakerHazardClearning = data?.caretakerHazardClearning !== null && data?.caretakerHazardClearning !== undefined ? data?.caretakerHazardClearning : null;
		this.caretakerQualifications = data?.caretakerQualifications || "";
		//cleaner
		this.cleanerExperience = data?.cleanerExperience || "";
		this.cleanerSchoolExperience = data?.cleanerSchoolExperience || "";
		this.cleanerEnjoment = data?.cleanerEnjoment || "";
		this.cleanerManageTime = data?.cleanerManageTime || "";
		this.cleanerSkill = data?.cleanerSkill !== null && data?.cleanerSkill !== undefined ? data?.cleanerSkill : null;
		this.cleaningEquipment = data?.cleaningEquipment !== null && data?.cleaningEquipment !== undefined ? data?.cleaningEquipment : null;
		this.cleaningDeepCleaning = data?.cleaningDeepCleaning !== null && data?.cleaningDeepCleaning !== undefined ? data?.cleaningDeepCleaning : null;
		this.cleaningHealthSafety = data?.cleaningHealthSafety !== null && data?.cleaningHealthSafety !== undefined ? data?.cleaningHealthSafety : null;
		this.cleaningChemicals = data?.cleaningChemicals !== null && data?.cleaningChemicals !== undefined ? data?.cleaningChemicals : null;
		this.cleaningOtherSkills = data?.cleaningOtherSkills || "";
		this.cleanerUrgentCleaning = data?.cleanerUrgentCleaning || "";
		this.cleanerPotentialHazards = data?.cleanerPotentialHazards || "";
		this.cleanerBalanceCleaning = data?.cleanerBalanceCleaning || "";
		this.cleanerResponsibility = data?.cleanerResponsibility || "";
		this.flexibleHours = data?.flexibleHours || "";
		this.openToDaytoDay = data?.openToDaytoDay !== null && data?.openToDaytoDay !== undefined ? data?.openToDaytoDay : null;
		this.openToShortTerm = data?.openToShortTerm !== null && data?.openToShortTerm !== undefined ? data?.openToShortTerm : null;
		this.openToLongTerm = data?.openToLongTerm !== null && data?.openToLongTerm !== undefined ? data?.openToLongTerm : null;
		this.currentAvailabilties = data?.currentAvailabilties || "";
		this.distanceToTravel = data?.distanceToTravel || "";
	}
}
